<template>
  <div class="disbursement-list">
    <KTCodePreview v-bind:title="title">
      <template v-slot:toolbar>
        <div>
          <router-link
            v-if="checkPermission('DISBURSEMENT_INSERT')"
            :to="{
              name: 'add-disbursement',
            }"
          >
            <b-button variant="primary" size="sm" class="font-weight-bolder">
              <i style="font-size: 1rem" class="flaticon2-add-1"></i> Tạo mới
            </b-button>
          </router-link>
        </div>
      </template>
      <template v-slot:preview>
        <b-row class="mb-5">
          <b-col>
            <b-input
              size="sm"
              placeholder="Id giải ngân"
              v-model="apiParams.id"
              v-on:keyup.enter="onFilter()"
              autocomplete="off"
            />
          </b-col>
          <b-col>
            <b-input
              size="sm"
              placeholder="Tên giải ngân"
              v-model="apiParams.disburseName"
              v-on:keyup.enter="onFilter()"
              autocomplete="off"
            />
          </b-col>
          <b-col>
            <b-input
              size="sm"
              placeholder="Tên file"
              v-model="apiParams.fileName"
              v-on:keyup.enter="onFilter()"
              autocomplete="off"
            />
          </b-col>
          <b-col>
            <b-input
              size="sm"
              placeholder="Ghi chú"
              v-model="apiParams.disburseNote"
              v-on:keyup.enter="onFilter()"
              autocomplete="off"
            />
          </b-col>
          <b-col> </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col cols="1">
            <b-button
              size="sm"
              variant="primary"
              style="fontweight: 600; width: 70px"
              @click="onFilter()"
              >Lọc</b-button
            >
          </b-col>
        </b-row>
        <div>
          <b-table
            :items="disbursements"
            :fields="disbursementsFields"
            :small="true"
            :busy="onLoading"
            responsive
            bordered
            hover
          >
            <template #cell(index)="data">
              {{
                (currentPage - 1) * pageSize + (data.index != null ? data.index : 0) + 1
              }}
            </template>
            <template #cell(disburseName)="data">
              <b>{{ data.item.disburseName }}</b>
            </template>
            <template #cell(info)="data">
              <ul class="list-unstyled mb-1">
                <li>
                  <span class="font-weight-bold">Tên file:</span>
                  {{ data.item.fileName }}
                </li>
                <li>
                  <span class="font-weight-bold">Mã tài khoản kế toán:</span>
                  {{ data.item.accountantId }}
                </li>
                 <li>
                  <span class="font-weight-bold">Nhà giải ngân:</span>
                  {{ data.item.disbursementConfig?.name }}
                </li>
                <li>
                  <span class="font-weight-bold">Ngày nhập:</span>
                  {{ data.item.importDate }}
                </li>
                <li>
                  <span class="font-weight-bold">Người tạo:</span>
                  {{ data.item.createdByName }}
                </li>
              </ul>
              <br />
            </template>
            <template #cell(actions)="data">
              <b-dropdown size="sm" no-caret right lazy>
                <template slot="button-content">
                  <i
                    style="font-size: 1rem"
                    class="flaticon2-settings pr-0"
                  ></i>
                </template>
                <b-dropdown-item
                  @click="redirectToDisbursementDetail(data.item.id)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-pen"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="checkPermission('DISBURSEMENT_INSERT')"
                  @click="showDeleteAlert(data.item.id)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <template v-slot:table-busy>
              <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
            </template>
          </b-table>
        </div>
        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Hiển thị {{ fromNo }} - {{ toNo }} / {{ convertPrice(totalItem) }} bản ghi
            </p>
          </b-col>
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="numberOfPage"
              :current-page="currentPage"
              :total-page="numberOfPage"
              @page-change="fetchDisbursements"
            />
          </b-col>
        </b-row>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
// import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
// import moment from 'moment';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { VclTable } from 'vue-content-loading';
import {
  handleError,
  makeToastSuccess,
  formatDate,
  convertPrice,
} from '@/utils/common';
import { TIME_OUT, TIME_TRIGGER } from '@/utils/constants';
import { cloneDeep, debounce } from 'lodash';
import Swal from 'sweetalert2';
import permissionMixin from '@/view/mixins/permission.mixin';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';

export default {
  mixins: [permissionMixin],
  data() {
    return {
      pageSize: 10,
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      apiParams: {
        id: null,
        disburseName: null,
        disburseNote: null,
      },
      title: '',
      disbursements: [],
      onLoading: false,
      numberOfPage: 1,
      totalItem: 0,
      disbursementsFields: [
        {
          key: 'index',
          label: 'STT',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: {
            width: '5%',
          },
        },
        {
          key: 'disburseName',
          label: 'Tên giải ngân',
          thClass: 'text-center',
          thStyle: {
            width: '13%',
          },
          tdClass: 'text-wrap',
        },
        {
          key: 'totalAmount',
          label: 'Tổng tiền',
          thClass: 'text-center',
          tdClass: 'text-center',
          formatter: function (value) {
            return convertPrice(value);
          },
        },
        {
          key: 'info',
          label: 'Thông tin',
          thClass: 'text-center',
          thStyle: {
            width: '15%',
          },
          thStyle: {
            width: '30%',
          },
        },
        {
          key: 'disburseNote',
          label: 'Ghi chú',
          thClass: 'text-center',
        },
        {
          key: 'createdAt',
          label: 'Ngày tạo',
          thClass: 'text-center',
          thStyle: {
            width: '9%',
          },
        },
        {
          key: 'actions',
          label: ' ',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: {
            width: '5%',
          },
        },
      ],
    };
  },
  components: {
    KTCodePreview,
    VclTable,
    BPaginationNavCustom,
  },
  computed: {
    currentPage() {
      return Number(this.$route.query.page) || 1;
    },
    fromNo() {
      if (!this.totalItem) return 0;
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    toNo() {
      return Math.min(this.currentPage * this.pageSize, this.totalItem);
    },
  },
  mounted() {
    this.title = 'Danh sách giải ngân';
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.title }]);
  },
  created() {
    this.onInitData();
    this.fetchDisbursements();
  },
  methods: {
    formatDate,
    convertPrice,
    onInitData() {},
    debounceInput: debounce((textInput, fn) => {
      fn(textInput);
    }, TIME_TRIGGER),
    onFilter() {
      this.$router.push({
        name: 'list-disbursement',
        query: { page: 1 },
      });
      this.fetchDisbursements(1);
    },
    onRefresh() {
      this.fetchDisbursements();
    },
    getParamFilters(page = this.currentPage) {
      const apiParams = cloneDeep(this.apiParams);

      return {
        ...apiParams,
        page,
        size: this.pageSize,
      };
    },
    fetchDisbursements(page) {
      if (this.onLoading) return;

      this.onLoading = true;
      this.disbursements = [];
      const params = this.getParamFilters(page || this.currentPage);

      ApiService.query('v1/disbursements', { params }, { timeout: TIME_OUT })
          .then((response) => {
            const dataset = response.data.data;
            this.totalItem = dataset.total;
            this.numberOfPage = dataset.total_page;
            this.disbursements = dataset.data;
            this.onLoading = false;
          })
        .catch((error) => {
          this.onLoading = false;
          this.$nprogress.done();
          handleError(error);
        });
    },
    viewDisbursement(id) {
      this.$router.push({
        name: 'update-disbursement',
        params: { id },
        query: { mode: 'view' },
      });
    },
    editDisbursement(id) {
      this.$router.push({
        name: 'update-disbursement',
        params: { id },
      });
    },
    redirectToDisbursementDetail(id) {
      this.$router.push({
        name: 'update-disbursement',
        params: { id },
        query: {
          mode: 'view',
        },
      });
    },
    removeDisbursement(id) {
      ApiService.delete(`v1/disbursements/${id}`)
        .then((response) => {
          const { message } = response.data;
          makeToastSuccess(message);
          this.onFilter();
        })
    },
    showDeleteAlert: function (id) {
      Swal.fire({
        title: 'Xóa giải ngân!',
        text: 'Bạn có chắc muốn xóa  giải ngân này không ? Lưu ý, việc xoá giải ngân sẽ xoá các giao dịch đã tạo từ giải ngân này.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      }).then((result) => {
        if (result.value) {
          this.removeDisbursement(id);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.disbursement-list {
  table tbody td {
    vertical-align: middle;
  }
}
</style>
